<div class="bmc-sap-cp-connector-list" [ngClass]="{'bmc-sap-cp-connector-list__hidden': isLoading}">
  <h4 class="bz-space--stack-m">{{'EXCEL_CONNECTOR.TITLE_LIST' | translate}}</h4>
  <div class="bmc-sap-cp-connector-list__search-box bz-space--stack-m">
    <bzg-input [placeholder]="('EXCEL_CONNECTOR.SEARCH_BY' | translate)"
               class="bmc-sap-cp-connector-list__search-box__text" name="search-box" [(ngModel)]="searchValue"
               actionIcnPosition="right">
      <bzg-icon nameIcon="icon-search"></bzg-icon>
    </bzg-input>
  </div>
  <ul *ngIf="connectors" class="bmc-sap-cp-connector-list__items">
    <li class="bmc-sap-cp-connector-list__item bz-space--inset-squish-m bz-space--stack-s bz-shadow--xs bz-border-radius--m"
        [ngClass]="{'bz-color-bg--theme-100': (!!selectedConnector && (selectedConnector.name === connector.name)), 'bmc-sap-cp-connector-list__item--on-delete': false}"
        *ngFor="let connector of connectors | searchBy : searchValue : ['name']"
        (click)="selectConnector(connector)">
      <bzg-checkbox *ngIf="false"></bzg-checkbox>
      <div class="bmc-sap-cp-connector-list__item__texts"
           [ngClass]="{'bmc-sap-cp-connector-list__item__texts--on-delete': false}">
        <h5 class="bz-font-weight--semibold" [ngClass]="{'bz-space--stack-s': (true)}">{{ connector.name }}</h5>
      </div>
      <svg class="bz-icn bz-icon-svg--16">
        <use href="#icon-arrow-right-bold"></use>
      </svg>
    </li>
  </ul>
</div>
